import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface PainItem {
  icon: string;
  title: string;
  desc: string;
}

interface ParkingPainPointsProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    items: PainItem[];
  };
}

export default function ParkingPainPoints({ data }: ParkingPainPointsProps) {
  const a = accent('gold');

  return (
    <section id="pain" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <div className="h-full rounded-2xl bg-foreground-950 border border-foreground-800 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-secondary-500/50">
                <div className="flex items-center gap-3">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-heading font-bold text-background-50 text-lg">{item.title}</h3>
                </div>
                <p className="mt-4 text-sm text-foreground-300 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}